export const foundingExperience = [
  {
    discipline: "Marketplace operations",
    headline: "Founded. Built. Operated.",
    description:
      "Founded a marketplace, built its software, and ran its operations. We lived the daily reality of manual work.",
  },
  {
    discipline: "Enterprise operations",
    organizations: ["Concentrix", "Genpact", "Accenture"],
    description: "Experience inside global enterprise services and operations.",
  },
  {
    discipline: "Engineering",
    organizations: ["Oracle", "Cisco"],
    description:
      "Experience building within enterprise technology organizations.",
  },
];

export const emergingTeamExperience = [
  {
    status: "Early contributors from",
    organizations: ["Google", "Meta", "Tools for Humanity", "Uber"],
  },
  {
    status: "Prospective founding team from",
    organizations: ["Anthropic", "Snowflake", "OpenAI", "NVIDIA"],
  },
];

// Recruiting interests, not current team affiliations or partner claims.
export const talentFrontiers = [
  {
    title: "Multi-screen, multi-interface & multi-device intelligence",
    organizations:
      "Anthropic / OpenAI / Google DeepMind / Adept / UI-TARS / Qwen / AutoGLM",
    evidence:
      "Computer use made interfaces computable. We take that intelligence across screens and devices: shared context, concurrent actions, and reliable recovery across interfaces.",
  },
  {
    title: "Agent systems & runtime",
    organizations:
      "Browser Use / Skyvern / Browserbase / Steel / Manus / H Company / Microsoft",
    evidence:
      "Multi-agent orchestration, persistent sessions, and recovery across thousands of runs on local and remote devices.",
  },
  {
    title: "Frontier models & learning",
    organizations:
      "OpenAI / Anthropic / Google DeepMind / Meta FAIR / Mistral / Thinking Machines / Cohere / SSI / xAI",
    evidence:
      "Original model architectures and learning methods, alongside post-training, distillation, and evaluations. Show measurable gains against strong baselines in capability, reliability, and efficiency.",
  },
  {
    title: "Systems & product engineering",
    organizations:
      "Google / Meta / Apple / Microsoft / Amazon / NVIDIA / Stripe / Palantir / Waymo / Tesla / SpaceX",
    evidence:
      "Products and infrastructure shipped at scale. The performance numbers, failure modes, and decisions behind them.",
  },
  {
    title: "Multi-device & screen use",
    organizations:
      "Carnegie Mellon / Berkeley / Stanford / UW / HKU / Tsinghua / Peking / Toronto / Waterloo / IISc",
    evidence:
      "Original research enabling digital humanoids to use computers, phones, tablets, watches, and browsers concurrently. Parallel and remote device use, shared context, and reliable handoffs across devices.",
  },
  {
    title: "Foundational research",
    organizations:
      "MIT / Stanford / Harvard / Caltech / Princeton / Carnegie Mellon / Berkeley / Cambridge / Oxford / ETH / EPFL",
    evidence:
      "Deep work in learning, perception, systems, and optimization, paired with the ability to turn an idea into a working system.",
  },
];
